module.exports = __webpack_public_path__ + "fonts/ralewaybold.09136a7.woff2";